// extracted by mini-css-extract-plugin
export var codeBanner = "styles-mod--code-banner--83cb8";